import React from "react";

import FirebaseContext from "contexts/FirebaseContext";

const useFirebaseContext = () => React.useContext(FirebaseContext);

export default useFirebaseContext;
